module.exports = __webpack_public_path__ + "img/ico-bars3.698cacfd.svg";